import React from "react";

export default function MegaphoneIcon({ ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      {...props}
    >
      <path
        d="M2.58098 7.85274H3.60202V2.97367H2.58098C1.18367 2.97367 0.428711 3.70854 0.428711 5.05563V5.77169C0.428711 7.11466 1.18367 7.85274 2.58098 7.85274ZM4.32533 7.85776C5.76833 8.0207 7.25808 8.45472 8.69435 9.16259C8.69161 9.10422 8.69071 9.04083 8.69071 8.98246V1.84907C8.69071 1.78428 8.69161 1.72864 8.69345 1.66476C7.26833 2.36858 5.6464 2.83033 4.32533 2.97367V7.85776ZM10.4806 10.36C11.115 10.36 11.5603 9.91062 11.5603 9.28259V1.51006C11.5603 0.877954 11.115 0.428558 10.4806 0.428558C9.85351 0.428558 9.40411 0.877954 9.40411 1.51006V9.28259C9.40411 9.91062 9.85351 10.36 10.4806 10.36ZM4.62506 11.3098C5.27315 11.3098 5.75637 10.8295 5.57851 10.0398L5.29364 8.74392C4.84321 8.65602 4.21243 8.59996 2.9246 8.57026C2.83691 8.57026 2.69659 8.56199 2.55125 8.56109L3.42935 10.416C3.69583 10.9788 4.01354 11.3098 4.62506 11.3098Z"
        fill={props.fill ?? "white"}
      />
    </svg>
  );
}
